import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class CalculationService {

	roundDownNumberToDecimalPlaces(numberToConvert: number) {
		return Math.floor(numberToConvert * 100) / 100;
	}

	calculateTranchePayment(amount: number, numPayments: number, nextPaymentAmount = true): number {
		// First tranche calculation: divide the amount by numPayments and round down
		const initialTrancheAmount = this.roundDownNumberToDecimalPlaces(amount / numPayments);

		// Multiply initial tranche amount by numPayments to see if it gives us the whole number again
		const totalDistributed = initialTrancheAmount * numPayments;

		// // Subtract the total distributed from the original amount to find the remainder
		const trancheRemainder = this.roundDownNumberToDecimalPlaces(amount - totalDistributed);

		// // Create an array of tranche payments filled with the initial tranche amount
		const tranchePayments: number[] = Array(numPayments).fill(initialTrancheAmount);

		// // If numPayments is greater than 0, add the remainder to the first tranche payment
		if (numPayments > 0) {
			tranchePayments[0] = this.roundDownNumberToDecimalPlaces(tranchePayments[0] + trancheRemainder);
		}

		// // Return the first tranche payment
		return nextPaymentAmount ? tranchePayments[tranchePayments.length - 1] : tranchePayments[0];
	}
}
